import React from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Card, CardBody, CardTitle } from "reactstrap";
import DatePicker from "react-datepicker";
import { IoCashOutline, IoCash } from "react-icons/io5";
import { GetLanguageString } from "../../../helper/Components";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  applyClassToCharacters,
  customOption,
  getStringFromJSX,
  isUrdu,
} from "../../../../constants/const";
import { Table } from "reactstrap";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { GetCustomStyles } from "../../../helper/Method";

const AmanatToCashAccountForm = ({
  setValues,
  values,
  errors,
  fundAccountBalances,
  handleInputChange,
  handleDateChange,
  handleBankAccountChange,
  isEdit = false,
  selectedBankAccount,
  unitBankAccounts,
  handleAddNew,
  showRowsTable,
  showExtraFile,
  handleChangeTableData,
  rows,
  addRow,
  removeRow,
  disableFileForFuture = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* BALANCE CARDS */}
      <Row>
        {/* Amanat Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <Card
            className="border-0 shadow-lg"
            style={{ backgroundColor: "#fef7ee", borderRadius: "20px" }}
          >
            <CardBody style={{ padding: "0.5rem" }}>
              <CardTitle tag="h5">
                <h4>
                  <GetLanguageString props="transactions_amanat_account_balance" />
                </h4>
              </CardTitle>

              <div className="d-flex align-items-center gap-2 my-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    backgroundColor: "#f9b468",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <IoCash size={24} color="white" />
                </div>

                <h3 className="mb-0">
                  Rs{" "}
                  {new Intl.NumberFormat().format(
                    fundAccountBalances.amanatAccountBalance
                  )}
                </h3>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Cash Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <Card
            className="border-0 shadow-lg"
            style={{ backgroundColor: "#E6FAF4", borderRadius: "20px" }}
          >
            <CardBody style={{ padding: "0.5rem" }}>
              <CardTitle tag="h5">
                <h4>
                  <GetLanguageString props="cash_account_balance" />
                </h4>
              </CardTitle>

              <div className="d-flex align-items-center gap-2 my-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    backgroundColor: "#20D4A0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <IoCashOutline size={24} color="white" />
                </div>

                <h3 className="mb-0">
                  Rs{" "}
                  {new Intl.NumberFormat().format(
                    fundAccountBalances.cashAccountBalance
                  )}
                </h3>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Transfer Amount */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="funds_add_fund_amount" />
            </Label>
            <Input
              type="text"
              name="transferAmount"
              placeholder={t("funds_add_fund_amount")}
              value={values.transferAmount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "transferAmount", value: val },
                  });
                }
              }}
              invalid={!!errors.transferAmount}
            />
            {errors.transferAmount && (
              <FormFeedback>
                <h4>{errors.transferAmount}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Deposit Date */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="dashboard_event_page_date" />
            </Label>
            <DatePicker
              selected={values.requestDate}
              onChange={handleDateChange}
              className={`form-control ${
                errors.requestDate ? "is-invalid" : ""
              }`}
              dateFormat="dd/MM/yyyy"
            />
            {errors.requestDate && (
              <div className="invalid-feedback d-block">
                <h4>{errors.requestDate}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="fund_bank_account" />
            </Label>

            <div style={{ display: "flex", gap: "8px" }}>
              {/* Select */}
              <div style={{ flex: 1 }}>
                <Select
                  components={{
                    Option: customOption,
                  }}
                  options={unitBankAccounts}
                  value={{
                    value: selectedBankAccount?.value,
                    label: selectedBankAccount?.label
                      ? applyClassToCharacters(selectedBankAccount?.label, "ur")
                      : "",
                  }}
                  onChange={handleBankAccountChange}
                  placeholder="Select bank account"
                  classNamePrefix="select"
                />
              </div>

              {/* Small Button */}
              <Button
                color="primary"
                size="sm"
                onClick={() => handleAddNew(true)}
                style={{
                  height: "38px", // matches Select height
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 12px", // small compact button
                }}
              >
                <FaPlus
                  color="#f7f7f7ff"
                  size={11}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
                {t("tutorial_add_category")}
              </Button>
            </div>
          </FormGroup>
        </Col>

        {/* Memo */}
        <Col md={isEdit ? "6" : "6"}>
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_memo" />
            </Label>
            <Input
              type="textarea"
              name="memo"
              placeholder="Memo"
              className={isUrdu(values?.memo) ? "ur " : ""}
              value={
                values?.memo
                  ? getStringFromJSX(applyClassToCharacters(values?.memo, "ur"))
                  : ""
              }
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        {showExtraFile && (
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                <GetLanguageString props="transactions_shura_approval_attachment" />
              </Label>
              <Input
                type="file"
                name="extraFile"
                onChange={(e) =>
                  setValues((prev) => ({
                    ...prev,
                    extraFile: e.target.files[0],
                  }))
                }
                className={`form-control ${
                  errors.extraFile ? "is-invalid" : ""
                }`}
              />
              {errors.extraFile && (
                <div className="invalid-feedback d-block">
                  <h4>{errors.extraFile}</h4>
                </div>
              )}
            </FormGroup>
          </Col>
        )}
      </Row>

      {showRowsTable && (
        <>
          <hr />
          <Row>
            <div className="ibox">
              <div className="ibox-title">
                <h5>{<GetLanguageString props="sidebar_funds_expenses" />}</h5>
                <Button
                  className={GetCustomStyles().btn_style}
                  color="white"
                  size="xs"
                  onClick={addRow}
                >
                  <FaPlus
                    color="#18A689"
                    size={13}
                    style={{ marginRight: 5, marginBottom: 1 }}
                  />
                  {<GetLanguageString props="tutorial_add_category" />}
                </Button>
              </div>

              <div className="ibox-content">
                <Row>
                  <Col md="12">
                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>
                            {
                              <GetLanguageString props="sidebar_funds_expense" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="funds_add_fund_amount" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="dashboard_event_page_date" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="transactions_expense_type" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="transactions_expense_receipt" />
                            }
                          </th>
                          <th style={{ width: "40px" }}></th>
                        </tr>
                      </thead>

                      <tbody>
                        {rows.map((row, i) => (
                          <tr key={i}>
                            <td>
                              <Input
                                type="text"
                                value={row.description}
                                onChange={(e) =>
                                  handleChangeTableData(
                                    i,
                                    "description",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter description"
                                className={
                                  errors[`row_${i}_description`]
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {errors[`row_${i}_description`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_description`]}</h4>
                                </div>
                              )}
                            </td>

                            <td>
                              <Input
                                type="text"
                                value={row.amount}
                                onChange={(e) => {
                                  const val = e.target.value;

                                  // Allow only digits (empty allowed)
                                  if (/^\d*$/.test(val)) {
                                    handleChangeTableData(i, "amount", val);
                                  }
                                }}
                                placeholder="0"
                                className={
                                  errors[`row_${i}_amount`] ? "is-invalid" : ""
                                }
                              />

                              {errors[`row_${i}_amount`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_amount`]}</h4>
                                </div>
                              )}
                            </td>

                            <td>
                              <DatePicker
                                selected={
                                  row.date ? new Date(row.date) : new Date()
                                }
                                onChange={(date) =>
                                  handleChangeTableData(i, "date", date)
                                }
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                minDate={
                                  row.expenseType === "future"
                                    ? new Date()
                                    : null
                                }
                                maxDate={
                                  row.expenseType === "past" ? new Date() : null
                                }
                              />
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ gap: "25px", height: "100%" }}
                              >
                                {/* Past */}
                                <label
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Input
                                    type="radio"
                                    name={`expenseType_${i}`}
                                    value="past"
                                    checked={row.expenseType === "past"}
                                    onChange={(e) =>
                                      handleChangeTableData(
                                        i,
                                        "expenseType",
                                        e.target.value
                                      )
                                    }
                                    style={{ marginRight: "6px" }}
                                  />
                                  <span>
                                    {
                                      <GetLanguageString props="transactions_past" />
                                    }
                                  </span>
                                </label>

                                {/* Future */}
                                <label
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Input
                                    type="radio"
                                    name={`expenseType_${i}`}
                                    value="future"
                                    checked={row.expenseType === "future"}
                                    onChange={(e) =>
                                      handleChangeTableData(
                                        i,
                                        "expenseType",
                                        e.target.value
                                      )
                                    }
                                    style={{ marginRight: "6px" }}
                                  />
                                  <span>
                                    {
                                      <GetLanguageString props="transactions_future" />
                                    }
                                  </span>
                                </label>
                              </div>
                            </td>

                            <td>
                              <Input
                                type="file"
                                onChange={(e) =>
                                  handleChangeTableData(
                                    i,
                                    "file",
                                    e.target.files[0]
                                  )
                                }
                                disabled={
                                  disableFileForFuture &&
                                  row.expenseType === "future"
                                }
                                className={
                                  errors[`row_${i}_file`] ? "is-invalid" : ""
                                }
                              />

                              {errors[`row_${i}_file`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_file`]}</h4>
                                </div>
                              )}
                            </td>

                            {/* <td>
                              <Input
                                type="file"
                                onChange={(e) =>
                                  handleChangeTableData(i, "file", e.target.files[0])
                                }
                              />
                            </td> */}
                            <td style={{ width: "40px", textAlign: "center" }}>
                              {rows.length > 1 && (
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => removeRow(i)}
                                  style={{ padding: "5px 8px" }}
                                >
                                  <FaTrashAlt />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </>
      )}
    </>
  );
};
export default AmanatToCashAccountForm;
